import config from '@/lib/config';

export default function combinedSnapshots(snapshot, baseSnapshot) {
  const combined = structuredClone(config.DEFAULT_SNAPSHOT);

  combined.name = snapshot.name;
  combined.objective = snapshot.objective;
  combined.created_at = snapshot.created_at;
  combined.__hash = snapshot.__hash;

  for (const plural in snapshot.entities) {
    combined.entities[plural] = {
      ...baseSnapshot.entities[plural],
      ...snapshot.entities[plural],
    };
  }

  return combined;
}
